import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Pill from '../partials/Pill';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/blocks/pill.module.scss';

const propTypes = {
    title: PropTypes.string,
    body: PropTypes.string,
    colors: AppPropTypes.colors,
    image: AppPropTypes.image,
    video: AppPropTypes.video,
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    title: null,
    body: null,
    colors: null,
    image: null,
    video: null,
    className: null,
    isContainer: false,
    containerClassName: null,
};

const PillBlock = ({
    title,
    body,
    colors,
    image,
    video,
    className,
    isContainer,
    containerClassName,
}) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        <div
            className={classNames([
                styles.inner,
                {
                    [styles.isContainer]: isContainer,
                    [containerClassName]: isContainer && containerClassName !== null,
                },
            ])}
        >
            <Pill title={title} body={body} colors={colors} image={image} video={video} />
        </div>
    </div>
);

PillBlock.propTypes = propTypes;
PillBlock.defaultProps = defaultProps;

export default PillBlock;
